export default class Scroll {
    constructor() {
        this.init();
    }

    init() {
        this._cvbtnBehavior();
    }

    _cvbtnBehavior() {
        const $about = document.querySelector(".about");
        const $way = document.querySelector(".l-footer__way");
        const $cvbtn = document.querySelector(".page-nav__contact");

        if ($about !== null && $cvbtn !== null) {

            //コンタクトボタンの交差
            window.addEventListener("scroll", () => {
                const tgt_about = $about.getBoundingClientRect().top + window.pageYOffset;
                const tgt_way =
                    $way.getBoundingClientRect().top + window.pageYOffset;
                const scb = window.pageYOffset + window.innerHeight;

                if (scb >= tgt_about && scb <= tgt_way) {
                    $cvbtn.classList.add("-show");
                } else {
                    $cvbtn.classList.remove("-show");
                }
            });
        }
    }
}
